// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--AncgU","static":"_25d45facb5--static--wpBHh","video":"_25d45facb5--video--kJzCZ"};